// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"518a1805","453":"e0c3a94a","732":"425ad997","977":"3aef2e60"}[chunkId] + ".chunk.js";
};